<template>
  <div>
    <div v-if="!formsLoaded" class="text-center">
      <b-spinner label="Loading..." style="color:#002b36;"></b-spinner>
    </div>
    <b-card v-else no-body style="border:none;">
      <div v-if="(xs || (lg && !xl))" class="d-flex align-items center justify-content-center mobile-kub-dropdown-button" @click="toggleDropdownForm = !toggleDropdownForm">
        <span class="align-self-center">
          {{formType}}
        </span>
        <b-icon icon="chevron-down" class="align-self-center ml-auto"></b-icon>
      </div>
      <b-tabs v-model="changeFormTabIndex" pills card vertical :nav-wrapper-class="[{'mobile-kub-dropdown-auswahl': (xs || (lg && !xl))}, {'mt-1': (xs || (lg && !xl))}, {'col-12': true}, {'col-sm-5': true}, {'col-lg-12': true}, {'col-xl-5': true}, {'d-none': toggleDropdownForm && (xs || (lg && !xl))}]" active-tab-class="p-0 pt-3">
        <b-tab v-for="form in forms" :key="form.id" class="h-100" @click="resetFormSelected(), setFormType({type: form.type[0].name, code: form.type[0].code, img: form.type[0].cartImg}), setDraftFormType(form.type[0].draftFormType), initFormSize(form.type[0].sideNames), setRandSides(form.type[0].rand), initFormSizeHelper(form.type[0].sides.length), setCalcFactor(form.type[0].factor), initCalcSidesRand(form.type[0].rand.length), (xs || (lg && !xl)) ? toggleDropdownForm = !toggleDropdownForm : ''" :title-item-class="[{'mb-2': true}]">
          <template v-slot:title>
            <b-row>
              <b-col>
                {{form.title}}
              </b-col>
              <div class="w-100"></div>
              <b-col>
                <small class="font-weight-light">{{form.subtitle}}</small>
              </b-col>
            </b-row>
          </template>
          <b-card-text class="h-100">
            <b-container class="h-100">
              <b-row class="h-90">
                <b-col class="d-flex align-items-end justify-content-center">
                  <div>
                    <b-img-lazy :src="form.type[formSelected[form.id-1]].img.src" fluid :alt="form.type[formSelected[form.id-1]].img.alt" class="mb-2"></b-img-lazy>
                  </div>
                </b-col>
                <div class="w-100"></div>
                <b-col v-if="form.typeSelection.length > 1" cols="12" xl="10" class="ml-auto mr-auto">
                  <b-form>
                    <b-col>
                      <b-form-group
                        label-cols="2"
                        label-align="center"
                        label="Art:"
                        :label-for="form.typeSelectionId"
                        label-class="font-weight-bold"
                      >
                        <b-form-select :id="form.typeSelectionId" :value="formSelected[form.id-1]" @input="updateFormSelected({value: $event, index: form.id-1})" :options="form.typeSelection" @change="setFormType({type: form.type[$event].name, code: form.type[$event].code, img: form.type[$event].cartImg}), setDraftFormType(form.type[$event].draftFormType), initFormSize(form.type[$event].sideNames), setRandSides(form.type[$event].rand), initFormSizeHelper(form.type[$event].sides.length), setCalcFactor(form.type[$event].factor), initCalcSidesRand(form.type[$event].rand.length)"></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-form>
                </b-col>
                <div v-if="form.typeSelection.length > 1" class="w-100"></div>
                <b-col>
                  <p v-html="form.type[formSelected[form.id-1]].desc" style="textAlign:center;"></p>
                </b-col>
                <div class="w-100"></div>
                <b-col>
                  <b-form class="w-100">
                    <b-col v-for="(side, index) in form.type[formSelected[form.id-1]].sides" :key="side.id" cols="12" xl="10" class="ml-auto mr-auto">
                      <b-form-group
                        label-cols="2"
                        :description="side.labelDesc"
                        label-align="center"
                        :label="side.labelName"
                        :label-for="side.labelFor"
                        label-class="font-weight-bold"
                      >
                        <b-input-group append="cm">
                          <b-form-input
                            type="number"
                            :id="side.inputId"
                            v-model="formSizeHelper[index]"
                            @input="delayTouch($v.formSizeHelper[index])"
                            @change.native="$v.formSizeHelper[index].$model = $event.target.value, updateFormSize(side.name, formSizeHelper[index])"
                            :state="validateState($v.formSizeHelper[index])"
                            :aria-describedby="side.inputInvId"
                          ></b-form-input>
                        </b-input-group>
                        <div class="kub-form-error" v-if="$v.formSizeHelper[index].$dirty && !$v.formSizeHelper[index].between">Bitte Mindest- und Maximallänge beachten</div>
                        <div class="kub-form-error" v-if="$v.formSizeHelper[index].$dirty && !$v.formSizeHelper[index].required">Bitte Länge eingeben</div>
                        <div class="kub-form-error" v-if="$v.formSizeHelper[index].$dirty && ($v.formSizeHelper[index].between && $v.formSizeHelper[index].required) && (formType === forms.trapez.type[0].name && index === 1 && !$v.formSizeHelper[index].CsmallerA)"><strong>c</strong> muss kleiner als <strong>a</strong> sein</div>
                        <div class="kub-form-error" v-if="$v.formSizeHelper[index].$dirty && ($v.formSizeHelper[index].between && $v.formSizeHelper[index].required) && (formType === forms.trapez.type[1].name && index === 2 && !$v.formSizeHelper[index].CsmallerA)"><strong>c</strong> muss kleiner als <strong>a</strong> sein</div>
                        <div class="kub-form-error" v-if="$v.formSizeHelper[index].$dirty && ($v.formSizeHelper[index].between && $v.formSizeHelper[index].required) && (formType === forms.trapez.type[2].name && index === 1 && !$v.formSizeHelper[index].CsmallerA)"><strong>c</strong> muss kleiner als <strong>a</strong> sein</div>
                        <div class="kub-form-error" v-if="$v.formSizeHelper[index].$dirty && ($v.formSizeHelper[index].between && $v.formSizeHelper[index].required) && (formType === forms.trapez.type[3].name && index === 2 && !$v.formSizeHelper[index].DsmallerB)"><strong>d</strong> muss kleiner als <strong>b</strong> sein</div>
                        <div class="kub-form-error" v-if="$v.formSizeHelper[index].$dirty && ($v.formSizeHelper[index].between && $v.formSizeHelper[index].required) && (formType === forms.trapez.type[4].name && index === 2 && !$v.formSizeHelper[index].DgreaterB)"><strong>d</strong> muss größer als <strong>b</strong> sein</div>
                        <div class="kub-form-error" v-if="$v.formSizeHelper[index].$dirty && ($v.formSizeHelper[index].between && $v.formSizeHelper[index].required) && (formType === forms.trapez.type[5].name && index === 2 && !$v.formSizeHelper[index].CsmallerA)"><strong>c</strong> muss kleiner als <strong>a</strong> sein</div>
                        <div class="kub-form-error" v-if="$v.formSizeHelper[index].$dirty && ($v.formSizeHelper[index].between && $v.formSizeHelper[index].required) && (formType === forms.trapez.type[5].name && index === 3 && !$v.formSizeHelper[index].EsmallerB)"><strong>e</strong> muss kleiner als <strong>b</strong> sein</div>
                        <div class="kub-form-error" v-if="$v.formSizeHelper[index].$dirty && ($v.formSizeHelper[index].between && $v.formSizeHelper[index].required) && (formType === forms.trapez.type[6].name && index === 2 && !$v.formSizeHelper[index].DsmallerA)"><strong>d</strong> muss kleiner als <strong>a</strong> sein</div>
                        <div class="kub-form-error" v-if="$v.formSizeHelper[index].$dirty && ($v.formSizeHelper[index].between && $v.formSizeHelper[index].required) && (formType === forms.trapez.type[6].name && index === 3 && !$v.formSizeHelper[index].EgreaterB)"><strong>e</strong> muss größer als <strong>b</strong> sein</div>
                      </b-form-group>
                    </b-col>
                  </b-form>
                </b-col>
                <div class="w-100"></div>
                <b-col>
                  <p style="textAlign:center;">
                    <small class="kub-color"><strong>Hinweis</strong>: eingegebene Maße sind Endmaße, d.h. inkl. Saum, Hohlsaum oder Keder (falls gewählt)</small>
                  </p>
                </b-col>
              </b-row>
              <b-row class="h-10 d-flex align-items-end">
                <b-col cols="6" offset="6" :class="[{'pr-0': true}, {'pl-0': (xs || (lg && !xl))}]">
                  <b-button type="submit" href="#" block variant="link" class="kub-btn text-decoration-none d-flex align-items-center" :disabled="$v.formSizeHelper.$invalid" @click="updateForm(), changeStatusForm(), scrollToId()">
                    <span class="ml-auto mr-auto">Weiter</span>
                    <b-icon icon="chevron-right" font-scale="0.95"></b-icon>
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import DataSetup from '../../../../../data/main/config/setup/setup'
import DataService from './../../../../../services/DataService'

import { mapActions, mapGetters } from 'vuex'

import { required, integer, between } from 'vuelidate/lib/validators'

const touchMap = new WeakMap()

export default {
  data () {
    return {
      forms: {},
      formSizeHelper: {
        0: null,
        1: null,
        2: 100,
        3: 100
      },
      components: DataSetup.components,
      toggleDropdownForm: true,
      formsLoaded: false
    }
  },
  methods: {
    ...mapActions([
      'setFormType',
      'setFormSize',
      'initFormSize',
      'setRandSides',
      'setConfigForm',
      'changeStatusForm',
      'setFormTabIndex',
      'setDraftFormType',
      'setCalcFactor',
      'setCalcForm',
      'initCalcSidesRand',
      'formsLoadingError',
      'updateFormSelected',
      'resetFormSelected',
      'changeFormSizeHelperReset'
    ]),
    initFormSizeHelper (length) {
      if (length === 1) {
        this.formSizeHelper = {
          0: null,
          1: 100,
          2: 100,
          3: 100
        }
      } else if (length === 2) {
        this.formSizeHelper = {
          0: null,
          1: null,
          2: 100,
          3: 100
        }
      } else if (length === 3) {
        this.formSizeHelper = {
          0: null,
          1: null,
          2: null,
          3: 100
        }
      } else {
        this.formSizeHelper = {
          0: null,
          1: null,
          2: null,
          3: null
        }
      }
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    validateState (vobj) {
      const { $dirty, $error } = vobj
      return $dirty ? !$error : null
    },
    updateFormSize (name, value) {
      this.setFormSize({ name, value })
    },
    updateForm () {
      this.$v.$reset()
      this.setConfigForm({ type: this.formType, size: this.formSize, img: this.formImage })
      this.setCalcForm({ type: this.formType, size: this.formSize })
      this.$root.$emit('bv::toggle::collapse', this.components.material.toggle)
    },
    delayTouch ($v) {
      $v.$reset()
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v))
      }
      touchMap.set($v, setTimeout($v.$touch, 300))
    },
    scrollToId () {
      if (this.lg) {
        document.getElementById('kub-heading-setup').scrollIntoView()
      } else {
        document.getElementById('kub-heading-draft').scrollIntoView()
      }
    }
  },
  validations () {
    switch (this.formType) {
      case this.forms.rechteck.type[0].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500)
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.dreieck.type[0].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500)
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.dreieck.type[1].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500)
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.dreieck.type[2].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500)
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.trapez.type[0].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500),
              CsmallerA () {
                if (this.formSizeHelper[0]) {
                  return parseFloat(this.formSizeHelper[1]) < parseFloat(this.formSizeHelper[0])
                } else {
                  return true
                }
              }
            },
            2: {
              required,
              integer,
              between: between(30, 2500)
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.trapez.type[1].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500),
              CsmallerA () {
                if (this.formSizeHelper[0]) {
                  return parseFloat(this.formSizeHelper[2]) < parseFloat(this.formSizeHelper[0])
                } else {
                  return true
                }
              }
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.trapez.type[2].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500),
              CsmallerA () {
                if (this.formSizeHelper[0]) {
                  return parseFloat(this.formSizeHelper[1]) < parseFloat(this.formSizeHelper[0])
                } else {
                  return true
                }
              }
            },
            2: {
              required,
              integer,
              between: between(30, 2500)
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.trapez.type[3].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500),
              DsmallerB () {
                if (this.formSizeHelper[1]) {
                  return parseFloat(this.formSizeHelper[2]) < parseFloat(this.formSizeHelper[1])
                } else {
                  return true
                }
              }
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.trapez.type[4].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500),
              DgreaterB () {
                if (this.formSizeHelper[1]) {
                  return parseFloat(this.formSizeHelper[2]) > parseFloat(this.formSizeHelper[1])
                } else {
                  return true
                }
              }
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.trapez.type[5].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500),
              CsmallerA () {
                if (this.formSizeHelper[0]) {
                  return parseFloat(this.formSizeHelper[2]) < parseFloat(this.formSizeHelper[0])
                } else {
                  return true
                }
              }
            },
            3: {
              required,
              integer,
              between: between(30, 2500),
              EsmallerB () {
                if (this.formSizeHelper[1]) {
                  return parseFloat(this.formSizeHelper[3]) < parseFloat(this.formSizeHelper[1])
                } else {
                  return true
                }
              }
            }
          }
        }
      case this.forms.trapez.type[6].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500),
              DsmallerA () {
                if (this.formSizeHelper[0]) {
                  return parseFloat(this.formSizeHelper[2]) < parseFloat(this.formSizeHelper[0])
                } else {
                  return true
                }
              }
            },
            3: {
              required,
              integer,
              between: between(30, 2500),
              EgreaterB () {
                if (this.formSizeHelper[1]) {
                  return parseFloat(this.formSizeHelper[3]) > parseFloat(this.formSizeHelper[1])
                } else {
                  return true
                }
              }
            }
          }
        }
      case this.forms.kreis.type[0].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500)
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.halbkreis.type[0].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500)
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.polygon.type[0].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500)
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.polygon.type[1].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500)
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.polygon.type[2].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500)
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
      case this.forms.polygon.type[3].name:
        return {
          formSizeHelper: {
            0: {
              required,
              integer,
              between: between(30, 2500)
            },
            1: {
              required,
              integer,
              between: between(30, 2500)
            },
            2: {
              required,
              integer,
              between: between(30, 2500)
            },
            3: {
              required,
              integer,
              between: between(30, 2500)
            }
          }
        }
    }
  },
  computed: {
    ...mapGetters([
      'width',
      'xs',
      'sm',
      'md',
      'lg',
      'xl',
      'formType',
      'formSize',
      'formImage',
      'formTabIndex',
      'formSelected',
      'formSizeHelperReset'
    ]),
    changeFormTabIndex: {
      get () {
        return this.formTabIndex
      },
      set (value) {
        this.setFormTabIndex(value)
      }
    }
  },
  watch: {
    formSizeHelperReset: function () {
      if (this.formSizeHelperReset) {
        this.formSizeHelper = {
          0: null,
          1: null,
          2: 100,
          3: 100
        }
        this.changeFormSizeHelperReset()
      }
    }
  },
  async created () {
    try {
      this.forms = await DataService.getForms()
      this.formsLoaded = true
    } catch (err) {
      this.formsLoadingError()
      console.log(err)
    }
  }
}
</script>

<style scoped>
  .input-group-text {
    background-color: rgba(0, 0, 0, 0.03) !important;
  }

  .kub-form-error{
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
  }
</style>
